import { IconPencil } from '@tabler/icons-react'
import React from 'react'

import { Button } from '@/components/buttons/Button'

export const EditButton = ({ onEdit, ...props }) => {
  return (
    <Button data-testid="edit-button" square basic small onClick={onEdit} {...props}>
      <IconPencil />
    </Button>
  )
}
